<template>
  <div class="popup">
    <div class="questions__topic">
      <span class='questions__add'></span>Add a new question or <a href="" @click.prevent="onShowSelectQuestionModal()">link an existing question</a>
    </div>
    <div class="questions__output">Сhoose the type of question</div>
    <div class="questions__select">
      <vue-select :options="questionTypeOptions" v-model="questionType" @change="onShowCreateQuestionModal($event)"></vue-select>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'ModalCreateQuestion',
    data() {
      return {
        questionType: null,

        addedQuestionIds: [],
        sort: null,
        sortList: [],
        poll_id: null,
      }
    },
    computed: {
      ...mapGetters([
        'getModalData',
        'getQuestionTypes',
      ]),
      questionTypeOptions() {
        let arr = []
        for (let type in this.getQuestionTypes)
          arr.push({id: type, text: this.getQuestionTypes[type]})
        return arr
      },
    },
    mounted() {
      this.addedQuestionIds = this.getModalData.addedQuestionIds
      this.sort = this.getModalData.sort
      this.sortList = this.getModalData.sortList
      this.poll_id = this.getModalData.poll_id
      
      console.log(this.sort)
    },
    methods: {
      ...mapActions([
        'showModal',
        'closeModal',
      ]),
      onShowSelectQuestionModal() {
        let data = {
          added_base_questions: this.addedQuestionIds
        }
        if (this.poll_id)
          data.poll_id = this.poll_id
        else
          data.is_draft = true
        data.sort = this.sort
        this.closeModal(true)
        this.showModal({modal: 'ModalSelectSurveyQuestion', data: data})
      },
      onShowCreateQuestionModal(val) {
        if (this.poll_id) {
          this.showModal({
            modal: 'ModalSurveyQuestion',
            data: {
              poll_id: this.poll_id,
              type: val,
              sort: this.sort
            }
          })
        } else {
          this.showModal({
            modal: 'ModalSurveyQuestion',
            data: {
              is_draft: true,
              type: val,
              sort: this.sort
            }
          })
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.questionType = null
          }, 500)
        })
      },
    }
  }
</script>

<style>

</style>